import { Component } from '@angular/core';

@Component({
  selector: 'app-cifriscloud24',
  templateUrl: './cifriscloud24.component.html',
  styleUrl: '../../../../../../../../styles-tabelle-orari.css'
})
export class Cifriscloud24Component {

}
